import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import SettingForm from './SettingFormik'

interface IAddVehicleColorModalProps extends RouteComponentProps {
  createVehicleColor: (name: string) => Promise<any>
}

export default class AddColorModal extends React.Component<IAddVehicleColorModalProps> {
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <SettingForm onSubmit={this.onAdd} title='ADD COLOR' labelTitle='Color'>
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Add
              </button>
            </SettingForm>
          </div>
        </div>
      </Modal>
    )
  }

  private onAdd = (input: string) => {
    return new Promise<void>(approve => {
      this.props.createVehicleColor(input).then(() => {
        approve()
        setTimeout(() => {
          this.onCancel()
        }, 1000)
      })
    })
  }

  private onCancel = () => {
    this.props.history.push('/global-settings/color')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AddColorModal.tsx